import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import './index.css'

// Filter out known noisy console warnings in development
// These are React Flow warnings that occur when edges reference handles
// on nodes that haven't fully rendered yet - this is expected behavior
// and not a bug in the application
if (import.meta.env.DEV) {
  const originalWarn = console.warn
  console.warn = (...args: unknown[]) => {
    const message = args[0]
    if (typeof message === 'string') {
      // Filter React Flow edge/handle warnings
      if (message.includes('[React Flow]:') && message.includes("Couldn't create edge")) {
        return // Suppress this warning
      }
    }
    originalWarn.apply(console, args)
  }
}

const rootElement = document.getElementById('root')
if (!rootElement) {
  throw new Error('Failed to find root element')
}

ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)
